import * as resolvers from 'app/infrastructure/ui/renderer/resolvers';
import { StoreData } from 'app/types-shared';
import { getById } from 'app/infrastructure/store/query';
import { getEntityTypeFromStorePath } from 'app/infrastructure/store/entity';
import { tableName } from 'app/area/case/case-data-model';
import { contextToStorePath } from 'app/infrastructure/ui/renderer/resolvers';

//This is a very temporary selector that replaces the Risk Matrix for the first release. Do not use!
export const consequenceRiskValues = (caseState, uiEngineProps) => {
  const caseData: StoreData = resolvers.getCaseData(caseState, uiEngineProps);

  const entityContext = resolvers.getEntityContext(caseState, uiEngineProps);

  const entity = getById(
    caseData,
    contextToStorePath(uiEngineProps.componentDescriptor, entityContext)
  );

  const entityType = entity && getEntityTypeFromStorePath(entity.id);

  const riskAreaField =
    entityType === tableName.lossPotentialEvaluationConsequence
      ? 'PotRiskRiskArea'
      : 'ResPotRiskRiskArea';
  const riskWeightField =
    entityType === tableName.lossPotentialEvaluationConsequence
      ? 'PotRiskWeight'
      : 'ResPotRiskWeight';

  return {
    riskArea: resolvers.getComponentValues(
      caseState,
      uiEngineProps,
      riskAreaField
    ).valueItem,
    riskWeight: resolvers.getComponentValues(
      caseState,
      uiEngineProps,
      riskWeightField
    ).value
  };
};
